<div [innerHTML]="urlPreviewData.remainder"></div>
@if (urlPreviewData['rootUrl'] != null) {
  <div class="pb-3" style="display: flex; min-width: 194px; min-height: 100px">
    @if (urlPreviewData['rootUrl'] != null) {
      <img src="assets/img/urlPreviewPlaceholder.png" alt="" style="width: 100px; height: 100px; flex: 0 0 auto;margin-right: 2px;">
    }
    @if (urlPreviewData['rootUrl'] != null) {
      <div class="mx-5 url-info">
        <label style="color:#17191D; font-size: 14px">Url Name Title </label>
        <label style="color: #828281;font-size: 12px">Url Description </label>
        <label class="preview-root-url">{{urlPreviewData['rootUrl']}}</label>
      </div>
    }
  </div>
}
@if (urlPreviewData['rootUrl'] != null) {
  <a id="huhuh" class="pull-left mt-0 preview-main-url" href="{{urlPreviewData['mainUrl']}}" target="_blank">
    {{urlPreviewData['mainUrl']}}
  </a>
}